module.exports = __webpack_public_path__ + "img/prepack-poster-image.9d6f8b4b.jpg";